import $ from "jquery";

const tags = () => {
  if (document.querySelector("[data-tags]")) {
    $("[data-value]").on("click", (e) => {
      e.preventDefault();
      $("[data-value]").removeAttr("data-active");
      $(e.currentTarget).attr("data-active", "");
      $("[name=\"your-subject\"]").val($(e.currentTarget).data("value"));
    });
  }
};

export default tags;
